import { createFileRoute } from "@tanstack/react-router";

import { KeyTablesStep } from "~/pages/onboard/steps/key-tables-step";

/**
 * Key-tables step. Shown after the catalog step once the user proceeds. The
 * id-bearing path means the URL is shareable / refreshable without losing the
 * datasource context.
 */
export const Route = createFileRoute("/onboard/key-tables/$datasourceId")({
  component: () => {
    const { datasourceId } = Route.useParams();
    return <KeyTablesStep datasourceId={datasourceId} />;
  },
});
